"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectEntityByCategorizerItem = exports.selectValueFromCategorizerItemProps = exports.selectFilterOpenStatus = exports.selectCategorizerOpenStatus = exports.selectCategorizerData = exports.selectCategorizerFetchStatus = exports.selectFixedTournamentIds = exports.selectOpenedGameIds = exports.selectCategorizer = exports.selectFilters = void 0;
var reselect_1 = require("reselect");
var core_1 = __importDefault(require("@gin-betting/core"));
var fieldMapping = {
    sport_id: 'sports',
    'tournament.id': 'tournaments',
    'tournament.master_id': 'tournaments',
};
var selectEntities = core_1.default.entities.selectors.selectEntities;
var selectFilters = function (state) { return state.filters; };
exports.selectFilters = selectFilters;
exports.selectCategorizer = reselect_1.createSelector(exports.selectFilters, function (filters) { return filters.categorizer; });
exports.selectOpenedGameIds = reselect_1.createSelector(exports.selectCategorizer, function (categorizer) { return categorizer.openedGameIds; });
exports.selectFixedTournamentIds = reselect_1.createSelector(exports.selectCategorizer, function (categorizer) { return categorizer.fixedTournamentIds; });
exports.selectCategorizerFetchStatus = reselect_1.createSelector(exports.selectCategorizer, function (categorizer) { return categorizer.fetchStatus; });
exports.selectCategorizerData = reselect_1.createSelector(exports.selectCategorizer, function (categorizer) { return categorizer.items; });
exports.selectCategorizerOpenStatus = reselect_1.createSelector(exports.selectCategorizer, function (categorizer) { return categorizer.isOpen; });
exports.selectFilterOpenStatus = reselect_1.createSelector(exports.selectFilters, function (filters) { return filters.isOpen; });
var selectValueFromCategorizerItemProps = function (_, props) { return ({
    field: props.categorizerItem.field,
    value: props.categorizerItem.value,
}); };
exports.selectValueFromCategorizerItemProps = selectValueFromCategorizerItemProps;
exports.selectEntityByCategorizerItem = reselect_1.createSelector(exports.selectValueFromCategorizerItemProps, selectEntities, function (_a, entities) {
    var field = _a.field, value = _a.value;
    return entities.get(fieldMapping[field]).get(value);
});
//# sourceMappingURL=selectors.js.map